import { observer } from 'mobx-react-lite'
import { useRef } from 'react'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { SpinnerLoader } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type Integration } from 'entities/Integrations'
import { SendFromMulti } from 'widgets/SendFromMulti'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { IntegrationIntercomSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationIntercomSettings/store/IntegrationIntercomSettingsStore'
import styles from './styles.module.scss'

type IIntegrationIntercomConnectInboxProps = {
  integration: Integration
}

export const IntegrationIntercomConnectInbox = observer(
  ({ integration }: IIntegrationIntercomConnectInboxProps) => {
    const entities = useEntitiesContext()
    const isMounted = useRef(false)
    const { connectInboxStore } = useIntegrationStoreMemo(
      IntegrationIntercomSettingsStore,
      integration,
      entities
    )

    if (connectInboxStore.loading || !connectInboxStore.sendFromMultiStore) {
      return <SpinnerLoader ariaLabel={'IntegrationIntercomConnectInbox'} />
    }

    const { sendFromMultiStore, updateMapping } = connectInboxStore

    return (
      <SendFromMulti
        store={sendFromMultiStore}
        textFieldPlaceholderProps={{
          size: 'medium',
          variant: 'stroke',
          className: styles.selectInboxesDropdown,
        }}
        rightActions={[makeTextFieldIcon({ icon: 'chevronDown' })]}
        triggerProps={{
          selectedOptionsCount: 2,
          isShowIcon: false,
          shouldShowSelectedItems: false,
          showNumbersCount: true,
          emptyPlaceholder: 'Select inbox(es)',
        }}
        width={720}
        scrollBarMaxHeight={130}
        dropdownProps={{
          placeholder: 'Search inbox',
          propsDropdownList: {
            autoHeightMax: 224,
          },
          onChangeOpen: (isOpen) => {
            if (!isMounted.current) {
              isMounted.current = true
              return
            }

            if (isOpen) return

            updateMapping()
          },
        }}
        dropdownGroupProps={{
          showSelectAllButton: true,
          dropdownItemsByGroup: sendFromMultiStore.dropdownItemsByGroup,
          showGroupHeader: true,
          isMultiSelect: true,
          stylesWrap: {
            padding: '6px 4px 8px',
          },
        }}
        popperProps={{
          offset: [0, -42],
        }}
        error={
          sendFromMultiStore.error
            ? { message: sendFromMultiStore.error, placement: 'top' }
            : undefined
        }
      />
    )
  }
)
